// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/time-filled-brand.svg';

export const TimeFilledBrand = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
